import { teamColor } from "./teamColor";

export interface TeamPillProps {
  slug: string;
  displayName: string;
  size?: "sm" | "md";
}

export function TeamPill({ slug, displayName, size = "sm" }: TeamPillProps): JSX.Element {
  const c = teamColor(slug);
  const padding = size === "sm" ? "2px 8px" : "4px 12px";
  const fontSize = size === "sm" ? 12 : 14;
  return (
    <span
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding, fontSize, fontWeight: 600,
        borderRadius: 999, color: c.fg, backgroundColor: c.bg, lineHeight: 1.6,
      }}
    >
      {displayName}
    </span>
  );
}
